// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"73af6c29","139":"8caf4687","141":"28634315","368":"b7955081","447":"b914c803","551":"a15df013","835":"fc5b08c0","955":"b2759078"}[chunkId] + ".chunk.js";
};